module.exports = __webpack_public_path__ + "assets/pin-12a9b4ed40987e22e90685b518148925.svg";